import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import HostUser from './host-user';
import HostGroup from './host-group';
import type { User } from '../types/User';
import type { Group } from '../types/Group';

const useStyles = makeStyles()((theme) => ({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  in: {
    margin: theme.spacing(0, 0.5),
  },
}));

type HostEvent = {
  hostType?: string;
  user?: User;
  group?: Group;
};

type Props = {
  event: HostEvent;
  className?: string;
  simple?: boolean;
  target?: string;
};

const Host = ({ event, className, simple, ...rest }: Props) => {
  const { classes, cx } = useStyles();
  const { hostType, group, user } = event;

  if (hostType === 'Group') {
    return (
      <HostGroup group={group} className={className} simple={simple} {...rest} />
    );
  } else if (hostType === 'User') {
    return (
      <div className={cx(classes.link, className)}>
        <HostUser user={user} simple={simple} {...rest} />
        {group && (
          <Fragment>
            <span className={classes.in}> in </span>
            <HostGroup group={group} simple={simple} skipVerification {...rest} />
          </Fragment>
        )}
      </div>
    );
  }
};

export default Host;
